import React from 'react'
import { Checkbox } from 'primereact/checkbox'

const BooleanBodyTemplate = ({ rowData, field }) => {
    return (
        <Checkbox
            checked={rowData[field] || false}
            disabled={true}
        />
    )
}

export default BooleanBodyTemplate
